// extracted by mini-css-extract-plugin
module.exports = {"cli4kc2":"cli4kc2","c1xve3c2":"c1xve3c2"};